import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/** Shared React Query keys — invalidate these when wallet balance changes. */
export const queryKeys = {
  profile: ['profile'] as const,
  paymentStatus: (sessionId: string) => ['payment', 'status', sessionId] as const,
};
